import React from 'react'

const ArrowSidebarFilter = (props) => (
  <svg width="24"
       height="24"
       fill={props.color ? props.color : '#1D79FB'}
       className={props.className ? props.className : ''}
       viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3601 5.2303C12.4611 5.14609 12.5778 5.08265 12.7034 5.04361C12.829 5.00456 12.9611 4.99068 13.092 5.00276C13.223 5.01483 13.3503 5.05263 13.4667 5.11398C13.583 5.17533 13.6861 5.25904 13.7701 5.3603L18.7701 11.3603C18.9172 11.5392 18.9976 11.7637 18.9976 11.9953C18.9976 12.2269 18.9172 12.4514 18.7701 12.6303L13.9401 18.6303C13.846 18.7463 13.727 18.8398 13.5921 18.9038C13.4571 18.9678 13.3095 19.0008 13.1601 19.0003C12.9708 19.0009 12.7853 18.9479 12.625 18.8473C12.4647 18.7467 12.3363 18.6027 12.2546 18.432C12.1729 18.2613 12.1414 18.0709 12.1636 17.883C12.1858 17.695 12.2609 17.5173 12.3801 17.3703L16.7101 12.0003L12.2301 6.6303C12.0631 6.4268 11.9832 6.16568 12.0075 5.90359C12.0318 5.6415 12.1585 5.39958 12.3601 5.2303Z"
    />
    <path
      d="M9.71007 12L5.23007 6.63002C5.06033 6.4258 4.97867 6.16252 5.00305 5.8981C5.02743 5.63367 5.15586 5.38976 5.36007 5.22002C5.56429 5.05028 5.82757 4.96862 6.092 4.993C6.35642 5.01738 6.60033 5.1458 6.77007 5.35002L11.7701 11.35C11.9172 11.529 11.9976 11.7534 11.9976 11.985C11.9976 12.2166 11.9172 12.4411 11.7701 12.62L6.94007 18.62C6.84595 18.736 6.72703 18.8295 6.59205 18.8935C6.45708 18.9576 6.30947 18.9905 6.16007 18.99C5.97084 18.9907 5.7853 18.9376 5.62503 18.837C5.46475 18.7364 5.3363 18.5924 5.25462 18.4217C5.17294 18.251 5.14136 18.0606 5.16357 17.8727C5.18578 17.6848 5.26085 17.507 5.38007 17.36L9.71007 12Z"
    />
  </svg>
)

export default ArrowSidebarFilter
